import NoteHeader from './NoteHeader';

export default NoteHeader;